import { render } from "./Carrusel-Component-2.vue?vue&type=template&id=1648fb28&scoped=true"
import script from "./Carrusel-Component-2.vue?vue&type=script&lang=js"
export * from "./Carrusel-Component-2.vue?vue&type=script&lang=js"

import "./Carrusel-Component-2.vue?vue&type=style&index=0&id=1648fb28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1648fb28"]])

export default __exports__